import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTimescaleComponent } from './simple-icons-timescale.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTimescaleComponent ],
    exports:      [ SimpleIconsTimescaleComponent ],
    bootstrap:    []
})
export class SimpleIconsTimescaleModule {}
